module.exports = __webpack_public_path__ + "assets/img/cooperation.ff89d37e.webp";